{
    "Accessibility Menu": "Barrierefreiheit",
    "Reset settings": "Einstellungen zurücksetzen",
    "Close": "Schließen",
    "Content Adjustments": "Inhaltsanpassungen",
    "Adjust Font Size": "Schriftgröße anpassen",
    "Highlight Title": "Titel hervorheben",
    "Highlight Links": "Links hervorheben",
    "Readable Font": "Lesbare Schrift",
    "Color Adjustments": "Farbanpassungen",
    "Dark Contrast": "Dunkler Kontrast",
    "Light Contrast": "Heller Kontrast",
    "High Contrast": "Hoher Kontrast",
    "High Saturation": "Hohe Farbsättigung",
    "Low Saturation": "Niedrige Farbsättigung",
    "Monochrome": "Monochrom",
    "Tools": "Werkzeuge",
    "Reading Guide": "Lesehilfe",
    "Protanopia": "Protanopie",
    "Deuteranopia": "Deuteranopie",
    "Tritanopia": "Tritanopie",
    "Visual & Navigation Aids": "Visuelle & Navigationshilfen",
    "Additional Tools": "Weitere Werkzeuge",
    "Stop Animations": "Animationen stoppen",
    "Big Cursor": "Großer Cursor",
    "Screen Reader": "Bildschirmleser",
    "Hide Images": "Bilder ausblenden",
    "Image Tooltips": "Bild-Tooltips",
    "Page Structure": "Seitenstruktur",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupe",
    "Increase Font Size": "Schriftgröße vergrößern",
    "Decrease Font Size": "Schriftgröße verkleinern",
    "Letter Spacing": "Zeichenabstand",
    "Line Height": "Zeilenhöhe",
    "Font Weight": "Schriftstärke",
    "Dyslexia Font": "Dyslexie-Schrift",
    "Language": "Sprache",
    "Open Accessibility Menu": "Barrierefreiheitsmenü öffnen",
    "Accessibility Profiles": "Barrierefreiheitsprofile",
    "Seizure Safe Profile": "Anfallsicheres Profil",
    "Stops animations and reduces color saturation.": "Stoppt Animationen und reduziert die Farbsättigung.",
    "Blind Profile": "Blindenprofil",
    "Activates the screen reader for auditory navigation.": "Aktiviert den Bildschirmleser für die auditive Navigation.",
    "Visually Impaired Profile": "Sehbehindertenprofil",
    "Enhances contrast and readability for low vision.": "Verbessert Kontrast und Lesbarkeit für Sehbehinderte.",
    "ADHD Friendly Profile": "ADHD-freundliches Profil",
    "Reduces distractions for better focus.": "Reduziert Ablenkungen für bessere Konzentration.",
    "Cognitive & Learning Profile": "Kognitives & Lernprofil",
    "Helpful tools for reading and comprehension.": "Hilfreiche Tools zum Lesen und Verstehen.",
    "Motor Impaired Profile": "Motorisches Profil",
    "Optimizes the site for keyboard-only navigation.": "Optimiert die Website für reine Tastaturnavigation.",
    "Headings": "Überschriften",
    "Landmarks": "Orientierungspunkte",
    "Links": "Links",
    "Focus element": "Element fokussieren",
    "Visit link": "Link besuchen"
}